export const environment = {
  production: true,
  buildId: '3446243432922141',
  configFile: 'config.json',
};
